// API configuration
// In production on Vercel, use relative URLs (proxy to Railway)
// In development, use localhost backend
export const API_BASE_URL = process.env.NODE_ENV === 'production'
  ? '' // Use Vercel proxy (rewrites in vercel.json)
  : 'http://localhost:5001';

// Debug logging
console.log('🔧 API Configuration:', {
  NODE_ENV: process.env.NODE_ENV,
  REACT_APP_API_URL: process.env.REACT_APP_API_URL,
  API_BASE_URL,
});
